import Vue from 'vue'
import App from './app.vue'
import { microApps, defaultApp } from './apps'
import { registerMicroApps, start, setDefaultMountApp } from 'qiankun'

const defaultMountApp = defaultApp ? defaultApp : microApps[0].activeRule

new Vue({
    mounted() {
        registerMicroApps(microApps, {
            beforeMount: (app = {}) => {
                if (app.props && app.props.code) {
                    sessionStorage.setItem('applicationCode', app.props.code)
                }
            },
            afterMount: (app = {}) => {
                if (app.props && app.props.mounted) app.props.mounted()
            },
            beforeUnmount: (app = {}) => {
                if (app.props) {
                    if (app.props.mounted && app.props.id) {
                        const _script = document.getElementById(app.props.id)
                        if (_script) _script.remove()
                    }
                }
            }
        })
        setDefaultMountApp(defaultMountApp)
        start()
    },
    render: h => h(App)
}).$mount('#app')
